<template>
  <div class="field_error">
    <span class="error">{{ errorMessage }}</span>
  </div>
</template>

<script>
import {ref,watch} from "vue";

export default {
  name: "Error",
  props:{
    error:String
  },
  setup(props){
    const errorMessage = ref(props.error);
    watch(() => props.error, (message) => {
      errorMessage.value = message;
    });
    return{
      errorMessage
    }
  }
};
</script>

<style scoped>

</style>